module.exports = __webpack_public_path__ + "img/Prong Too Short.6b2d6d0b.png";